import React from 'react'
import { Products } from './components/Products'
import { Totals } from './components/Totals'
import { TotalsCart } from 'components/Cart/components/TotalsCart'

export const CartOverview = () => {
  return (
    <div>
      <Products />
      <Totals />
      <TotalsCart />
    </div>
  )
}
